/*
 * gsk-header.js - Verhalten der schwebenden GSK-Header-Pille.
 * Portiert das Verhalten aus dem CMS-Frontend (chrome/nav.css beschreibt die
 * JS-States in den Kommentaren + die CMS-Header-Komponente).
 *
 * Zustaende:
 *   - .gsk-nav--stuck   : nach kurzem Scroll schrumpft die Pille
 *   - .gsk-nav--hidden  : weiter runter scrollend faehrt die Pille nach oben raus
 *                         (kommt beim Hochscrollen zurueck)
 *   - .menu-open        : Mobile-Drawer offen
 *   - .is-open (am .gsk-nav-has-sub) : Desktop-Dropdown offen
 *   - .is-sub-open (am .gsk-mobile__drawer) : Mobile-Drilldown auf Submenu
 *
 * Reines Vanilla-JS, keine Abhaengigkeiten. Mehrfach-Instanz-sicher (pro
 * <gsk-header> ein Controller). Idempotent gegen Shopify-Section-Re-Render.
 *
 * FIX: DESKTOP_BURGER_MAX war 1199 — bei 5 Menüpunkten + Logo + Icons +
 * CTA-Button hat das nicht gereicht, ein Teil der Menüpunkte (z.B. SALE/
 * KONTAKT) wurde schon vor dem eigentlichen Umschalten aufs Burger-Menü
 * abgeschnitten. Auf 1399 angehoben — MUSS mit den beiden Media-Queries in
 * gsk-header.liquid (aktuell "max-width: 1399px" / "min-width: 1400px")
 * uebereinstimmen, sonst zeigt CSS Nav/Burger anders an, als wofuer das JS
 * gerade Hover/Klick-Verhalten aktiviert.
 */
(function () {
  'use strict';

  var STUCK_THRESHOLD = 48; // ab hier Pille schrumpfen (spaeter, ruhiger)
  var HIDE_DELTA = 16; // Mindest-Scrolldistanz pro Tick gegen Flackern/Hupfen
  var DESKTOP_BURGER_MAX = 1399; // ab hier sind alle Links im Burger (Stufe 2b)
  var CLOSE_DELAY = 180; // ms Close-Delay fuer Desktop-Dropdown (Aim Tolerance)

  function initHeader(root) {
    if (!root || root.dataset.gskHeaderInit === 'true') return;
    root.dataset.gskHeaderInit = 'true';

    var pill = root.querySelector('.gsk-nav-pill');
    var burger = root.querySelector('.gsk-nav-burger');
    var mobile = root.querySelector('.gsk-mobile');
    var drawer = root.querySelector('.gsk-mobile__drawer');
    var closeBtn = root.querySelector('.gsk-mobile__close');
    var track = root.querySelector('.gsk-mobile__track');

    // ── Scroll-States (stuck / hidden) ──────────────────────────────
    var lastY = window.scrollY || 0;
    var ticking = false;

    function onScroll() {
      var y = window.scrollY || 0;

      // stuck: kleine Pille ab Schwelle
      if (y > STUCK_THRESHOLD) {
        root.classList.add('gsk-nav--stuck');
      } else {
        root.classList.remove('gsk-nav--stuck');
      }

      // hidden: runter -> raus, hoch -> rein. Nie bei offenem Menue.
      var delta = y - lastY;
      if (!root.classList.contains('menu-open') && Math.abs(delta) > HIDE_DELTA) {
        if (delta > 0 && y > 400) {
          root.classList.add('gsk-nav--hidden');
        } else {
          root.classList.remove('gsk-nav--hidden');
        }
      }
      lastY = y;
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(onScroll);
          ticking = true;
        }
      },
      { passive: true }
    );
    onScroll();

    // ── Mobile-Drawer oeffnen/schliessen ────────────────────────────
    function openDrawer() {
      if (!mobile) return;
      mobile.setAttribute('data-open', 'true');
      root.classList.add('menu-open');
      root.classList.remove('gsk-nav--hidden');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
    }

    function closeDrawer() {
      if (!mobile) return;
      mobile.setAttribute('data-open', 'false');
      root.classList.remove('menu-open');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      closeSub();
    }

    if (burger) {
      burger.addEventListener('click', function () {
        if (root.classList.contains('menu-open')) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });
    }
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    // Drawer-Link-Klick schliesst (eigene Seite oder Anker)
    if (drawer) {
      drawer.addEventListener('click', function (e) {
        var a = e.target.closest('a[href]');
        if (a && !a.classList.contains('is-placeholder')) closeDrawer();
      });
    }

    // ── Mobile-Drilldown (eine Ebene) ───────────────────────────────
    function openSub(index) {
      if (!drawer) return;
      var panels = drawer.querySelectorAll('.gsk-mobile__sub-panel');
      panels.forEach(function (p) {
        p.hidden = p.getAttribute('data-sub-index') !== String(index);
      });
      drawer.classList.add('is-sub-open');
    }
    function closeSub() {
      if (!drawer) return;
      drawer.classList.remove('is-sub-open');
    }

    root.querySelectorAll('.gsk-mobile__expand').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openSub(btn.getAttribute('data-sub-index'));
      });
    });
    var subBack = root.querySelector('.gsk-mobile__sub-back');
    if (subBack) subBack.addEventListener('click', closeSub);

    // ── Desktop-Dropdown (hover + click, Aim Tolerance) ─────────────
    var subItems = root.querySelectorAll('.gsk-nav-has-sub');
    subItems.forEach(function (li) {
      var trigger = li.querySelector('.gsk-nav-link');
      var closeTimer = null;

      function open() {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        // andere offene Dropdowns schliessen
        subItems.forEach(function (other) {
          if (other !== li) other.classList.remove('is-open');
        });
        li.classList.add('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      }
      function scheduleClose() {
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          li.classList.remove('is-open');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }, CLOSE_DELAY);
      }

      // Nur am <li>, nicht am Submenu (relatedTarget-Check gegen Re-Entry-Race)
      li.addEventListener('mouseenter', function () {
        if (window.innerWidth > DESKTOP_BURGER_MAX) open();
      });
      li.addEventListener('mouseleave', function (e) {
        if (e.relatedTarget && li.contains(e.relatedTarget)) return;
        scheduleClose();
      });

      // Tastatur/Touch: Klick auf den Trigger toggelt im Burger-Bereich nicht
      if (trigger) {
        trigger.addEventListener('focus', function () {
          if (window.innerWidth > DESKTOP_BURGER_MAX) open();
        });
        // Touch-Geraete ohne Hover: erster Tap oeffnet, zweiter folgt dem Link
        trigger.addEventListener('click', function (e) {
          if (window.innerWidth > DESKTOP_BURGER_MAX && !li.classList.contains('is-open')) {
            e.preventDefault();
            open();
          }
        });
      }
    });

    // ── Globales Escape + Outside-Click ─────────────────────────────
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (root.classList.contains('menu-open')) {
        closeDrawer();
        if (burger) burger.focus();
      }
      subItems.forEach(function (li) {
        li.classList.remove('is-open');
      });
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) {
        subItems.forEach(function (li) {
          li.classList.remove('is-open');
        });
      }
    });

    // Beim Wechsel ueber den Burger-Breakpoint einen offenen Drawer aufraeumen
    var mq = window.matchMedia('(min-width: ' + (DESKTOP_BURGER_MAX + 1) + 'px)');
    function onMqChange(ev) {
      if (ev.matches && root.classList.contains('menu-open')) closeDrawer();
    }
    if (mq.addEventListener) {
      mq.addEventListener('change', onMqChange);
    } else if (mq.addListener) {
      mq.addListener(onMqChange);
    }
  }

  function initAll() {
    document.querySelectorAll('gsk-header').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify Theme-Editor: Section-Re-Render -> neu initialisieren
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('gsk-header') : null;
    if (el) initHeader(el);
  });
})();